import { StubScreen } from '../StubScreen';

// Stub (DIT-671). Real content lands in DIT-683 (3.1 business-address).
export const BusinessAddressScreen = () => (
  <StubScreen
    id="business-address"
    heading="Wo ist Ihr Unternehmen ansässig?"
  />
);
